module.exports = {
    "cell": "mce63b6806_cell",
    "table": "mce63b6806_table"
};